module.exports = [
  [
    /*
    AAAA
    AAAA
    AAAA
    */
    {
      x:0, y:0, w:6, h:6
    },
  ],

  [
    /*
    AAAAAAA
    AAAAAAA
    -------
    BBBBBBB
    BBBBBBB
    */
    {
      x:0, y:0, w:6, h:3,
    },
    {
      x:0, y:3, w:6, h:3,
    },
  ],

  [
    /*
    AAA|BBB
    AAA|BBB
    AAA|BBB
    AAA|BBB
    */
    {
      x:0, y:0, w:3, h:6,
    },
    {
      x:3, y:0, w:3, h:6,
    },
  ],

  [
    /*
    AAA|BBB
    AAA|BBB
    AAA|---
    AAA|CCC
    AAA|CCC
    */
    {
      x:0, y:0, w:3, h:6,
    },
    {
      x:3, y:0, w:3, h:3,
    },
    {
      x:3, y:3, w:3, h:3,
    },
  ],

  [
    /*
    AAAAAAA
    AAAAAAA
    -------
    BBB|CCC
    BBB|CCC
    */
    {
      x:0, y:0, w:6, h:3,
    },
    {
      x:0, y:3, w:3, h:3,
    },
    {
      x:3, y:3, w:3, h:3,
    },
  ],

  [
    /*
    AAAAAA|BBBBBB
    AAAAAA|BBBBBB
    AAAAAA|BBBBBB
    -------------
    CCCCCC|DDDDDD
    CCCCCC|DDDDDD
    CCCCCC|DDDDDD
    */
    {
      x:0, y:0, w:3, h:3,
    },
    {
      x:3, y:0, w:3, h:3,
    },
    {
      x:0, y:3, w:3, h:3,
    },
    {
      x:3, y:3, w:3, h:3,
    },
  ],

  [
    /*
    AAAAA|BBBBB
    AAAAA|BBBBB
    AAAAA|BBBBB
    AAAAA|BBBBB
    -----------
    CCCCC|DDDDD
    CCCCC|DDDDD
    */
    {
      x:0, y:0, w:3, h:4,
    },
    {
      x:3, y:0, w:3, h:4,
    },
    {
      x:0, y:4, w:3, h:2,
    },
    {
      x:3, y:4, w:3, h:2,
    },
  ],

  [
    /*
    AAAAAAAA|BBBB
    AAAAAAAA|BBBB
    AAAAAAAA|BBBB
    -------------
    CCCCCCCC|DDDD
    CCCCCCCC|DDDD
    CCCCCCCC|DDDD
    */
    {
      x:0, y:0, w:4, h:3,
    },
    {
      x:0, y:3, w:4, h:3,
    },
    {
      x:4, y:0, w:2, h:3,
    },
    {
      x:4, y:3, w:2, h:3,
    },
  ],

  [
    /*
    AAAAA|BBBBB
    AAAAA|BBBBB
    AAAAA|BBBBB
    AAAAA|BBBBB
    -----------
    CCC|DDD|EEE
    CCC|DDD|EEE
    */
    {
      x:0, y:0, w:3, h:4,
    },
    {
      x:3, y:0, w:3, h:4,
    },
    {
      x:0, y:4, w:2, h:2,
    },
    {
      x:2, y:4, w:2, h:2,
    },
    {
      x:4, y:4, w:2, h:2,
    },
  ],

  [
    /*
    AAAAAAAAAAAAAAAAA|CCCCCC
    AAAAAAAAAAAAAAAAA|CCCCCC
    AAAAAAAAAAAAAAAAA|CCCCCC
    AAAAAAAAAAAAAAAAA|------
    AAAAAAAAAAAAAAAAA|DDDDDD
    -----------------|DDDDDD
    BBBBBBBBBBBBBBBBB|DDDDDD
    BBBBBBBBBBBBBBBBB|------
    BBBBBBBBBBBBBBBBB|EEEEEE
    BBBBBBBBBBBBBBBBB|EEEEEE
    BBBBBBBBBBBBBBBBB|EEEEEE
    */
    {
      x:0, y:0, w:4, h:3,
    },
    {
      x:0, y:3, w:4, h:3,
    },
    {
      x:4, y:0, w:2, h:2,
    },
    {
      x:4, y:2, w:2, h:2,
    },
    {
      x:4, y:4, w:2, h:2,
    },
  ],
];
